<div id="main-content">

    <!-- Breadcrumb on the left -->
    <nav aria-label="breadcrumb" class="px-5 mb-0">
      <ol class="breadcrumb mb-0">
        <li class="breadcrumb-item"><a [routerLink]="['/home']">Workspaces</a></li>
        <li class="breadcrumb-item"><a [routerLink]="newUrl">Visual</a></li>
        <li class="breadcrumb-item active" aria-current="page">Source</li>
      </ol>
    </nav>
  
    <!-- Centered text -->
    <div class="flex-grow-1 d-flex justify-content-center">
      <p class="fs-5 mb-4 text-center">Source Information</p>
    </div>


  <div class="d-flex flex-column align-items-center">
  <div class="card" style="max-width: 50%; width: 100%;" *ngIf="source; else noSource">
    <div class="card-body">
      <!-- Source Details -->
      <ul class="list-group mb-3">
        <li class="list-group-item">
          <strong>Type of source:</strong> {{ source.dataSourceType }}
        </li>
        <li class="list-group-item">
            <strong>Connection details:</strong>
            <ul class="list-unstyled mt-2">
              <li *ngFor="let key of getKeys(source.connectionDetails)">
                <i><strong>{{ key }}:</strong></i> {{ source.connectionDetails[key] }}
              </li>
            </ul>
        </li>
      </ul>
    </div>
  </div>
</div>
</div>

<!-- Fallback content if source is not available -->
<ng-template #noSource>
  <div class="alert alert-warning text-center" style="max-width: 600px; margin: 0 auto;">
    No source available.
  </div>
</ng-template>
